<template>
    <aside class="menu">
        <p
            v-t="'Dashboard.projects'"
            class="
                is-capitalized
                has-text-weight-bold has-text-black
                is-size-6
                mb-1
                pl-3
                pb-1
            "
        ></p>
        <ul class="menu-list has-text-grey dashed">
            <li class="pb-1">
                <router-link
                    v-t="'Dashboard.mine'"
                    :to="{
                        path: '/dashboard',
                        query: {
                            filter: 'mine',
                        },
                    }"
                    exact
                />
            </li>
            <li v-if="hasSchool" class="pb-1">
                <router-link
                    v-t="'Dashboard.my_school_projects'"
                    :to="{
                        path: '/dashboard',
                        query: {
                            filter: 'mySchool',
                        },
                    }"
                    exact
                />
            </li>
            <li class="pb-1">
                <router-link
                    v-t="'Dashboard.other_users'"
                    :to="{
                        path: '/dashboard',
                        query: {
                            filter: 'invited',
                        },
                    }"
                    exact
                />
            </li>
        </ul>
        <p
            v-if="$store.getters.isTeacher"
            v-t="'Dashboard.my_school'"
            class="
                is-capitalized
                has-text-weight-bold has-text-black
                is-size-6
                mb-1
                pl-3
                pb-1
            "
        ></p>
        <ul v-if="$store.getters.isTeacher" class="menu-list dashed">
            <li class="pb-1">
                <router-link
                    v-t="'Dashboard.users'"
                    :to="{ name: 'school' }"
                    exact
                    tag="a"
                ></router-link>
            </li>
            <li class="pb-1">
                <router-link
                    v-t="'Dashboard.groups'"
                    :to="{ name: 'groups' }"
                    exact
                    tag="a"
                ></router-link>
            </li>
        </ul>
        <p
            v-t="'Dashboard.sessions'"
            class="
                is-capitalized
                has-text-weight-bold has-text-black
                is-size-6
                mb-1
                pl-3
                pb-1
            "
        ></p>
        <ul class="menu-list has-text-grey dashed">
            <li class="pb-1">
                <router-link
                    v-t="'Dashboard.mySessions'"
                    :to="{
                        path: '/dashboard/sessions',
                        query: {
                            filter: 'mine',
                        },
                    }"
                    exact
                ></router-link>
            </li>
            <li class="pb-1">
                <router-link
                    v-t="'Dashboard.playedSessions'"
                    :to="{
                        path: '/dashboard/sessions',
                        query: {
                            filter: 'played',
                        },
                    }"
                    exact
                ></router-link>
            </li>
        </ul>
        <p
            v-if="hasCommunities"
            v-t="'Dashboard.communities'"
            class="
                is-capitalized
                has-text-weight-bold has-text-black
                is-size-6
                mb-1
                pl-3
                pb-1
            "
        ></p>
        <ul v-if="hasCommunities" class="menu-list has-text-grey dashed">
            <li class="pb-1">
                <router-link
                    v-t="'Dashboard.my_communities'"
                    :to="{ name: 'communities' }"
                    exact
                    tag="a"
                ></router-link>
                <!--router-link
          v-t="'Dashboard.other_communities'"
          :to="{ name: 'communities-explorer' }"
          exact
          tag="a"
        >
                </router-link-->
            </li>
        </ul>

        <p
            v-if="isAdmin"
            v-t="'Dashboard.external_content'"
            class="
                is-capitalized
                has-text-weight-bold has-text-black
                is-size-6
                mb-1
                pl-3
                pb-1
            "
        ></p>
        <ul v-if="isAdmin" class="menu-list has-text-grey dashed">
            <li class="pb-1">
                <router-link
                    v-t="'Dashboard.import_content'"
                    :to="{ name: 'import' }"
                    exact
                    tag="a"
                ></router-link>
            </li>
        </ul>
    </aside>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            dropdownActive: false,
            dropdownText: 'mine',
        };
    },
    computed: {
        hasSchool() {
            return this.$store.getters.hasSchool;
        },
        hasCommunities() {
            return this.$store.getters.hasCommunities;
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
    },
    methods: {
        toggleMenu() {
            this.dropdownActive = !this.dropdownActive;
        },
    },
};
</script>

<style scoped>
.menu {
    padding-top: 2.4rem;
}
</style>
